import ccgname from './ccgname'
import tptariff from './tptariff'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  upload ({ state, commit, rootState }, params) {
    return rootState.axios.post('/ccfile/v1frontend/ccfile/upload', params, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/ccfile/v1frontend/ccfile/search', {params})
  },
  updateCheckFailure ({ state, commit, rootState }, params) {
    return rootState.axios.post('/ccfile/v1frontend/ccfile/update-check-failure', params)
  },
  checkGnameStatus ({ state, commit, rootState }, params) {
    return rootState.axios.post('/ccfile/v1frontend/ccfile/check-gname-status', params)
  },
  // 实名认证检查
  validateTradevans ({ state, commit, rootState }, params) {
    return rootState.axios.post('/ccfile/v1frontend/ccfile/validate-tradevans', params)
  },
  searchFilename ({ state, commit, rootState }, params) {
    return rootState.axios.get('/ccfile/v1frontend/ccfile/search-filename', {params})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    ccgname,
    tptariff,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ccfile/index.js